<template>
  <div>Sua don vị</div>
</template>

<script>
export default {
  name: "SuaDonVi"
};
</script>
